module.exports = __webpack_public_path__ + "static/media/pipes_finolex.728db9a9.jfif";